import React from "react";
import { Link } from "react-router-dom";
import {useTranslation} from 'react-i18next'
// import logo from "../../assets/white_logo.png";
import "./Footer.scss";
function Footer() {
  const {t} = useTranslation();
  const map = [
    // { id: 1, to: "/", name: t("navbar2") },
    { id: 2, to: "/", name:  t("navbar1")},
    { id: 3, to: "/online", name: t("navbar4") },
    { id: 5, to: "/teacher", name: t("navbar5") },
    { id: 4, to: "news", name: t("yangilipage_r") },
  ];
  const map2 = map.map((a) => (
    <li key={a.id}>
      <Link to={a.to}>{a.name}</Link>
    </li>
  ));
  return (
    <div className="Footer">
      <div className="wrapper container">
        <div className="left_box">
          {/* <a href="/">
            <img src={logo} alt="rasm bor edi!" />
          </a> */}
          <p>
            {t("ourHistory.title1")}
          </p>
        </div>
        <div className="right_box">
          <div className="navigation">
            <h6>{t("footer.quickLinks")}</h6>
            <ul>{map2}</ul>
          </div>
          <div className="contacts">
            <h6>{t("navbar5")}</h6>
            <p>
             <span>Online</span>
            </p>
           
            <p className="email">
            {t("footer.email")} <span>tuhtaevarobiahon@gmail.com
</span>
            </p>
            <p className="worktime">
            {t("footer.workTime")} <span>24 hours</span>
            </p>
          </div>
        </div>
      </div>
      <p className="copyright">Online akademy. Copyright<a href="http://softcity.uz">Robiya ©</a></p>
    </div>
  );
}

export default Footer;
